import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  alpha2: Alpha2CountryCode
}

type RegionInfo = {
  name: string
  code: string
  value: string
}

export type HydraGetRegionsResponse = {
  items: RegionInfo[]
}

export const HydraGetRegions = ({ alpha2 }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/countries/${alpha2}/regions.json`,
    withAuth: false,
  }

  return httpTools.sendRequest<HydraGetRegionsResponse>(request)
}
